import { craftQuoteUrl } from '@lib/util';
import { Link, Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../PDFProvider';
import { styles } from './styles';

type QuoteIdProps = {
  ecommerceUri?: string;
};

export function QuoteId({ ecommerceUri }: QuoteIdProps) {
  const { quoteId } = usePDFContext();

  return (
    <View style={[styles.section, styles.alignCenter, styles.maxWidthFull]}>
      <Text style={[styles.quoteNumber, styles.bold]}>Quotation {quoteId}</Text>
      <Text style={styles.textSmall}>
        Please refer to the quotation number when ordering
      </Text>

      {ecommerceUri ? (
        <Link href={craftQuoteUrl(ecommerceUri, quoteId)} style={styles.link}>
          Click to Purchase These Items Online
        </Link>
      ) : null}
    </View>
  );
}
